import * as React from 'react'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './accordion'

export interface IAccordionItem {
  id: string
  title: string
  content: React.ReactNode
}

export interface UI_AccordionProps {
  items: IAccordionItem[]
}

export const UIAccordion = ({ items }: UI_AccordionProps) => {
  return (
    <Accordion type='single' collapsible className='w-full'>
      {items.map((item, index) => (
        <AccordionItem key={item.id + index} value={item.id}>
          <AccordionTrigger className='text-right'>
            {item.title}
          </AccordionTrigger>
          <AccordionContent>{item.content}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
